import { SubJobInput } from '@/types/sub-job';
import { filterValueToQuery, camelObjectToSnakeObject } from '@/api';

export default function subJob(axios: any) {
  async function getSubJobs(filter: any) {
    try {
      const response = await axios.get(`/api/bom_items?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] getSubJobs Error', e);
    }
    return null;
  }

  async function getSubJobsForInternalTab(filter: any) {
    try {
      const response = await axios.get(`/api/bom_items?${filterValueToQuery(filter)}`);
      if (response?.status === 200) {
        return {
          data: {
            ...response.data.data,
            data: response.data.data.data.map((elm: any) => ({
              ...elm, allowedEditSize: false, allowedEditQC: false, allowedEditStartQC: false, allowedEditFinishQC: false, allowedToEditRemarks: false,
            })),
          },
        };
      }
    } catch (e) {
      console.error('[api/sub-job] getSubJobs Error', e);
    }
    return null;
  }

  async function getSubJob(id: number) {
    const response = await axios.get(`/api/bom_items/${id}`);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] updateSubJob Error', e);
    }
    return null;
  }

  async function searchSubJob(payload: any) {
    const response = await axios.post('/api/bom_items/search', payload);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] createSubJob Error', e);
    }
    return null;
  }

  async function createSubJob(payload: SubJobInput) {
    const response = await axios.post('/api/bom_items', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] createSubJob Error', e);
    }
    return null;
  }

  async function createSubJobMany(bomId: number, payload: SubJobInput) {
    const response = await axios.post(`/api/boms/${bomId}/storeMany`, { items: [camelObjectToSnakeObject(payload)] });
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] createSubJobMany Error', e);
    }
    return null;
  }

  async function duplicateSubJob(id: number, payload: any = {}) {
    const response = await axios.post(`/api/bom_items/${id}/duplicate`, payload);
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] duplicateSubJob Error', e);
    }
    return null;
  }

  async function updateSubJob(id: number | string, payload: SubJobInput) {
    const response = await axios.put(`/api/bom_items/${id}`, camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] updateSubJob Error', e);
    }
    return null;
  }

  async function massUpdateSubJob(payload: any) {
    const response = await axios.put('/api/bom_items/update', camelObjectToSnakeObject(payload));
    try {
      if (response.status === 200) {
        return response.data;
      }
    } catch (e) {
      console.error('[api/sub-job] massUpdateSubJob Error', e);
    }
    return null;
  }

  async function deleteSubJob(id: number) {
    const response = await axios.delete(`/api/bom_items/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/sub-job] updateSubJob Error', e);
    }
    return null;
  }

  async function deleteProcessLog(id: number) {
    const response = await axios.delete(`/api/bom_items_process_log/${id}`);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/sub-job] deleteProcessLog Error', e);
    }
    return null;
  }

  async function updateSubJobProcessStatus(id: number, payload: any) {
    const response = await axios.put(`/api/bom_items_process_log/${id}`, payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/sub-job] updateSubJobProcessStatus Error', e);
    }
    return null;
  }

  async function updateSubJobAmount(payload: any) {
    const response = await axios.post('/api/bom_items/update-amount', payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/sub-job] updateSubJobAmount Error', e);
    }
    return null;
  }

  async function storeUpdateSubJobAmount(payload: any) {
    const response = await axios.post('/api/bom_items/update-store-amount', payload);
    try {
      if (response.status === 200) {
        return '';
      }
    } catch (e) {
      console.error('[api/sub-job] storeUpdateSubJobAmount Error', e);
    }
    return null;
  }

  return {
    getSubJobs,
    getSubJobsForInternalTab,
    getSubJob,
    searchSubJob,
    createSubJob,
    updateSubJob,
    massUpdateSubJob,
    duplicateSubJob,
    deleteSubJob,
    createSubJobMany,

    updateSubJobAmount,

    deleteProcessLog,
    updateSubJobProcessStatus,
    storeUpdateSubJobAmount,
  };
}
